import { Injectable } from '@angular/core';
import { TimeZoneEntryDto } from '@osos/shared/api';
import { TimeZonePresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { TimeZoneParserV1Service } from '../../parsers/time-zone-parser/time-zone-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class TimeZoneFactoryService extends FactoryBase<
  TimeZoneEntryDto,
  TimeZonePresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: TimeZoneParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  override createPresenterModel(
    model: TimeZoneEntryDto,
  ): TimeZonePresenterModel {
    const parser = this.getParser(TimeZoneEntryDto, TimeZonePresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
  override createDataModel(
    presenter: TimeZonePresenterModel,
  ): TimeZoneEntryDto {
    const parser = this.getParser(TimeZoneEntryDto, TimeZonePresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }
}
